import { Form, Input, Modal, notification, Spin } from 'antd'
import { useTranslation } from 'react-i18next'

import useUpdateOrder from '../../../hooks/useUpdateOrder'
import { OrderContract } from '../../../types'

interface UpdateOrderNumberModalProps {
  isVisible: boolean
  onCancel: () => void
  onSuccess: () => void
  selectedRecord: OrderContract
}

const UpdateOrderNumberModal = ({
  isVisible,
  onCancel,
  onSuccess,
  selectedRecord,
}: UpdateOrderNumberModalProps) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const { updateOrder, updateOrderIsLoading } = useUpdateOrder()

  const orderNumberRules = [
    { required: true, message: t('order_modal.order_required') },
    {
      pattern: /^[0-9]+$/,
      message: t('order_modal.numeric_only'),
    },
  ]

  const getModalSubtitle = (record: OrderContract) => {
    const carrier = record.carrier?.businessName || ''
    const contract = record.contract || ''
    const order = record.orderNumber || ''

    return `${carrier} - ${contract} - ${order}`
  }

  const handleModalOk = () => {
    form
      .validateFields()
      .then(values => {
        if (selectedRecord && values.orderNumber) {
          // Llamar a updateOrder con callback de éxito
          updateOrder(
            { id: selectedRecord.id, payload: { orderNumber: values.orderNumber } },
            {
              onSuccess: () => {
                notification.success({
                  message: t('order_modal.update_success'),
                })
                onSuccess()
                form.resetFields()
              },
            },
          )
        }
      })
      .catch(error => {
        console.error('Error de validación del formulario:', error)
        notification.error({
          message: t('order_modal.validation_error'),
        })
      })
  }

  const handleModalCancel = () => {
    form.resetFields()
    onCancel()
  }

  return (
    <Modal
      title={
        <div>
          <div>{t('order_modal.title')}</div>
          {selectedRecord && (
            <div
              style={{ fontSize: '14px', color: '#666', fontWeight: 'normal', marginTop: '4px' }}
            >
              {getModalSubtitle(selectedRecord)}
            </div>
          )}
        </div>
      }
      open={isVisible}
      onOk={handleModalOk}
      onCancel={handleModalCancel}
      okText={t('order_modal.save')}
      cancelText={t('order_modal.cancel')}
      width={500}
      destroyOnClose
    >
      <Spin spinning={updateOrderIsLoading}>
        <Form initialValues={selectedRecord} form={form} layout="horizontal" preserve={false}>
          <Form.Item
            label={t('order_modal.order')}
            name="orderNumber"
            rules={orderNumberRules}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <Input placeholder={t('order_modal.order_placeholder')} style={{ width: '15.5rem' }} />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  )
}

export { UpdateOrderNumberModal }
